import React from 'react';
import PDF from "../../assets/images/breakfastMenu.png"
const PdfViewerBreakfast = () => {
  return (
    <div>
      <img src={PDF} className='h-auto' alt='breakfast menu' />
    </div>
  );
};

export default PdfViewerBreakfast;
